<template>
  <svg
    width="100%"
    height="3"
    viewBox="0 0 170 3"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <line
      x1="1.25"
      y1="1.70508"
      x2="168.75"
      y2="1.70508"
      :stroke="completed ? '#00AFAA' : '#CBC6C6'"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-dasharray="2 5"
    />
  </svg>
</template>

<script>
export default {
  props: ["completed"]
};
</script>
